const LabelMapper = {
  total: 'Total',
  revenue: 'Revenue',
  ratesAndAnnualCharges: 'Rates and Annual Charges',
  userChargesAndFees: 'User Charges and Fees',
  interestAndInvestmentRevenue: 'Interest and Investment Revenue',
  otherRevenue: 'Other Revenue',
  grantsAndContributionsProvidedForOperating:
    'Grants and Contributions Provided for Operating Purposes',
  grantsAndContributionsProvidedForCapital:
    'Grants and Contributions Provided for Capital Purposes',
  netGainsFromTheDisposalsOfAssets: 'Net Gains from the Disposal of Assets',
  NetShareOfInterestsInJointVenturesAndAssociates:
    'Net Share of Interests in Joint Ventures and Associates',
  expenses: 'Expenses',
  employeeBenefitsAndOnCosts: 'Employee Benefits and on Costs',
  borrowingCosts: 'Borrowing Costs',
  materialsAndContracts: 'Materials and Contracts',
  depreciationAndAmortisation: 'Depreciation and Amortisation',
  impairment: 'Impairment',
  otherExpenses: 'Other Expenses',
  netLossesFromDisposalOfAssets: 'Net Losses from Disposal of Assets',
  operatingResult: 'Operating Result',
  assets: 'Assets',
  currentAssets: 'Current Assets',
  nonCurrentAssets: 'Non Current Assets',
  miscellaneousNonCurrentAssets: 'Miscellaneous non Current Assets',
  liabilities: 'Liabilities',
  currentLiabilities: 'Current Liabilities',
  nonCurrentLiabilities: 'Non Current Liabilities',
  miscellaneousCurrentLiabilities: 'Miscellaneous Current Liabilities',
  miscellaneousNonCurrentLiabilities: 'Miscellaneous non Current Liabilities',
  operatingPerformance: 'Operating Performance',
  ownSourceOperatingRevenue: 'Own Source Operating Revenue',
  unrestrictedCurrentRatio: 'Unrestricted Current Ratio',
  debtServiceCoverRatio: 'Debt Service Cover Ratio',
  ratesAndAnnualChargesOutstandingPercentage:
    'Rates and Annual Charges Outstanding Percentage',
  cashExpenseCoverRatio: 'Cash Expense Cover Ratio',
  ordinaryRates: 'Ordinary Rates',
  specialRates: 'Special Rates',
  annualCharges: 'Annual Charges',
  specificUserCharges: 'Specific User Charges',
  statutoryAndRegulatoryCharges: 'Statutory and Regulatory Charges',
  otherCharges: 'Other Charges',
  cashAndCashEquivalents: 'Cash and Cash Equivalents',
  currentInvestments: 'Current Investments',
  currentReceivables: 'Current Receivables',
  currentInventories: 'Current Inventories',
  otherCurrentAssets: 'Other Current Assets',
  nonCurrentAssetsHeldForSale: 'Non Current Assets Held for Sale',
  nonCurrentInvestments: 'Non Current Investments',
  nonCurrentReceivables: 'Non Current Receivables',
  nonCurrentInventories: 'Non Current Inventories',
  infrastructurePropertyPlantAndEquipment:
    'Infrastructure Property Plant and Equipment',
  investmentsAccountedForUsingTheEquityMethod:
    'Investments Accounted for using the Equity method',
  investmentProperty: 'Investment Property',
  intangibleAssets: 'Intangible Assets',
  currentPayables: 'Current Payables',
  currentBorrowings: 'Current Borrowings',
  currentProvisions: 'Current Provisions',
  incomeReceivedInAdvance: 'Income Received in Advance',
  nonCurrentPayables: 'Non Current Payables',
  nonCurrentBorrowings: 'Non Current Borrowings',
  nonCurrentProvisions: 'Non Current Provisions',
  // New for qld
  otherRevenues: 'Other Revenues',
  capitalExpenses: 'Capital Expenses',
  infrastructurePropertyPlantEquipment:
    'Infrastructure Property Plant Equipment',
  operatingSurplusRatio: 'Operating Surplus Ratio',
  grantsContributionsProvidedForOperating:
    'Grants Contributions Provided For Operating',
  averageOsr: 'Average Operating Surplus Ratio',
  grantsContributionsProvidedForCapital:
    'Grants Contributions Provided For Capital',
  miscellaneous: 'Miscellaneous',
  netFinancialLiabilities: 'Net Financial Liabilities',
  assetSustainabilityRatio: 'Asset Sustainability Ratio',
  averageAsr: 'Average Asset Sustainability Ratio',
  relativeRiskAssessment: 'Relative Risk Assessment',
  averageRemainingUsefulLifeOfInfrastructureAssets:
    'Average Remaining useful life of infrastructure assets',
  _trend: 'Should not be displayed',
};
const labelMatcher = str => {
  const label = LabelMapper[str];
  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};
export default labelMatcher;



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js